<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Forgot Password v1 -->
    <div class="card mb-0">
      <div class="card-body">
        <a href="javascript:void(0);" class="brand-logo">
          <div class="brand-logo">
            <img
              src="../../../../../assets/images/pages/logo_white.png"
              alt="brand-logo"
            />
          </div>

        </a>

        <h4 class="card-title mb-1">Forgot Password? 🔒</h4>
        <p class="card-text mb-2">
          {{ 'COMMON.ENTER_EMAIL_RESET' | translate }}
        </p>

        <form
          class="auth-forgot-password-form mt-2"
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="onSubmit()"
        >
          <div class="form-group">
            <label for="forgot-password-email" class="form-label">Email</label>
            <input
              type="text"
              class="form-control"
              placeholder="john@example.com"
              formControlName="email"
              aria-describedby="forgot-password-email"
              tabindex="1"
              id="forgot-password-email"
              autofocus
              [ngClass]="{ 'is-invalid': f.email.errors && f.email.dirty }"
            />
            <div *ngIf="f.email.dirty && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email is required</div>
              <div *ngIf="f.email.errors.email">
                Email must be a valid email address
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-block mt-2"
            tabindex="2"
            [disabled]="forgotPasswordForm.invalid"
            rippleEffect
          >
            Send reset link
          </button>
        </form>

        <div class="text-center mt-2 w-full">
          <a routerLink="/auth/login" class="flex items-center justify-center gap-2">
            <i data-feather="arrow-left" class=""></i> Back to login
          </a>
        </div>
      </div>
    </div>
    <!-- /Forgot Password v1 -->
  </div>
</div>
